import React, { useState, useEffect, useRef } from 'react';
import { STATUS_LABELS, STATUS_COLORS } from './bookingConstants';
import { getNextStatuses } from './bookingTableHelpers';

const TERMINAL = ['completed', 'cancelled', 'rejected'];

const NEXT_LABEL = {
  confirmed: '✓ 확정',
  rejected: '✗ 거절',
  completed: '✓ 완료',
  cancelled: '✗ 취소',
};

export default function StatusCell({ booking, busy, onStatusChange, onDelete }) {
  const [open, setOpen] = useState(false);
  const cellRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (cellRef.current && !cellRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const status = booking.status;
  const nextStatuses = getNextStatuses(status);
  const isTerminal = TERMINAL.includes(status);

  const handleTransition = (target) => {
    setOpen(false);
    onStatusChange(booking.bookingId, target);
  };

  const handleDelete = () => {
    setOpen(false);
    onDelete(booking);
  };

  return (
    <div ref={cellRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        disabled={busy}
        onClick={() => setOpen(v => !v)}
        title="클릭으로 상태 변경"
        aria-haspopup="menu"
        aria-expanded={open}
        style={{
          padding: '4px 12px', borderRadius: 12, fontSize: '0.78rem',
          fontWeight: 600, color: '#fff', cursor: busy ? 'wait' : 'pointer',
          background: STATUS_COLORS[status] || '#999',
          border: 'none', opacity: busy ? 0.5 : 1,
        }}
      >
        {STATUS_LABELS[status] || status} ▾
      </button>

      {open && (
        <div
          role="menu"
          style={{
            position: 'absolute', top: 'calc(100% + 4px)', left: 0,
            minWidth: 140, background: 'var(--surface)', border: '1px solid var(--border)',
            borderRadius: 'var(--radius)', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 50, padding: 4,
          }}
        >
          {nextStatuses.map(target => (
            <button
              key={target}
              type="button"
              role="menuitem"
              onClick={() => handleTransition(target)}
              style={menuItemStyle}
            >
              {NEXT_LABEL[target]}
            </button>
          ))}
          {isTerminal && (
            <button
              type="button"
              role="menuitem"
              onClick={handleDelete}
              style={{ ...menuItemStyle, color: '#ff5252' }}
            >
              🗑 영구삭제
            </button>
          )}
          {!isTerminal && nextStatuses.length === 0 && (
            <div style={{ padding: 8, color: 'var(--text-muted)', fontSize: '0.8rem' }}>
              변경 가능한 상태가 없습니다
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const menuItemStyle = {
  display: 'block', width: '100%', textAlign: 'left',
  padding: '8px 12px', background: 'transparent', border: 'none',
  cursor: 'pointer', fontSize: '0.85rem', color: 'var(--text)',
  borderRadius: 4,
};
